import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { BUCKET_URL } from 'constants/index';
import { useEffect, useState } from 'react';
import { callGetParticipants } from 'services/ivr.service';
import { getName, stringAvatar } from 'utils';

const CallParticipants = ({ callSid }) => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    callGetParticipants(callSid).then(setParticipants);
  }, []);

  return (
    <Stack direction="row" justifyContent="center" spacing={2} sx={{ mb: 2 }}>
      {participants.map((participant, index) => {
        const { contact } = participant;
        const name = getName(contact);
        const img = contact.contact_image_full_url
          ? BUCKET_URL + contact.contact_image_full_url
          : null;
        return (
          <Avatar
            {...stringAvatar(name, { width: 36, height: 36 })}
            key={index}
            alt={name}
            src={img}
          />
        );
      })}
    </Stack>
  );
};

export default CallParticipants;
